import * as regionCode from 'common/constants/region-codes';
import { ServiceCategory } from './service-categories-types';

export const FETCH_SERVICE_CATEGORIES = {
  init: 'serviceCategories/FETCH_SERVICE_CATEGORIES/init',
  request: 'serviceCategories/FETCH_SERVICE_CATEGORIES/request',
  success: 'serviceCategories/FETCH_SERVICE_CATEGORIES/success',
  failure: 'serviceCategories/FETCH_SERVICE_CATEGORIES/failure',
  cancel: 'serviceCategories/FETCH_SERVICE_CATEGORIES/cancel',
} as const;

export const SERVICE_CATEGORIES_RESET = 'serviceCategories/RESET' as const;

export const SERVICE_CATEGORIES_STORE_NAME = 'serviceCategories' as const;

export const ROUGH_REPAIR: ServiceCategory = {
  topCategoryId: 99999,
  topCategoryName: 'Черновой ремонт',
  topCategoryType: "OUTSTORE",
  topCategoryUrl: '/uslugi/chernovoy-remont/',
};

export const ELECTRIC_UNDERFLOOR_HEATING: ServiceCategory = {
  topCategoryId: 99998,
  topCategoryName: 'Укладка электрического теплого пола',
  topCategoryType: "OUTSTORE",
  topCategoryUrl: '/uslugi/ukladka-teplogo-pola/',
};

export const ROUGH_REPAIR_REGION_LIST = [
  regionCode.KURSK,
  regionCode.LIPETSK,
  regionCode.STAVROPOL,
  regionCode.VORONEZH,
  regionCode.IRKUTSK,
  regionCode.KRASNOYARSK,
  regionCode.VOLGOGRAD,
  regionCode.IZHEVSK,
  regionCode.ORENBURG,
  regionCode.ARKHANGELSK,
  regionCode.KALININGRAD,
  regionCode.PSKOV,
  regionCode.BARNAUL,
  regionCode.NOVOSIBIRSK,
  regionCode.YAROSLAVL,
  regionCode.IVANOVO,
  regionCode.KOSTROMA,
  regionCode.N_NOVGOROD,
  regionCode.CHELYABINSK,
  regionCode.PERM,
  regionCode.MOSCOW,
  regionCode.EKATERINBURG,
  regionCode.KAZAN,
  regionCode.KEMEROVO,
  regionCode.OMSK,
  regionCode.ROSTOV_NA_DONU,
  regionCode.SAMARA,
  regionCode.SURGUT,
  regionCode.TVER,
  regionCode.TULA,
  regionCode.TYUMEN,
  regionCode.UFA,
  regionCode.CHEREPOVETS,
  regionCode.ST_PETERSBURG,
];
